export function fixEncoding(text: string) {
  try {
    return decodeURIComponent(escape(text));
  } catch {
    return text;
  }
}
